import api from './api';

/**
 * Dashboard Service
 * Fetches consolidated dashboard data for the current user
 */

/**
 * Get full dashboard data for current user
 * Returns role-appropriate content (student, faculty, coordinator data)
 * @param {string} term - Optional term filter
 */
export const getDashboard = async (term) => {
    const params = term ? { term } : {};
    const response = await api.get('/dashboard', { params });
    return response.data;
};

/**
 * Get upcoming sessions for current user
 */
export const getUpcomingSessions = async () => {
    const response = await api.get('/dashboard/sessions');
    return response.data;
};

/**
 * Get quick actions available for current user
 */
export const getQuickActions = async () => {
    const response = await api.get('/dashboard/actions');
    return response.data;
};

/**
 * Get recent activity for current user
 * @param {number} limit - Maximum number of activities to return
 */
export const getRecentActivity = async (limit = 10) => {
    const response = await api.get('/dashboard/activity', {
        params: { limit },
    });
    return response.data;
};

/**
 * Get everything waiting on the current user, soonest due first
 * @returns {Promise<{ items: Array<{ role: string, type: string,
 *   title: string, detail: string, dueAt: string|null, urgent: boolean,
 *   link: string }> }>}
 */
export const getTodos = async () => {
    const response = await api.get('/dashboard/todos');
    return response.data;
};

export default {
    getDashboard,
    getTodos,
    getUpcomingSessions,
    getQuickActions,
    getRecentActivity,
};
